import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { colors, ButtonReset } from '../../healtheraComponents'

const CheckBoxButton = props => {
  const { icon: Icon } = props

  return (
    <Button {...props}>
      <Icon />
    </Button>
  )
}

CheckBoxButton.propTypes = {
  icon: PropTypes.func.isRequired,
}

export default CheckBoxButton

export const Button = styled(ButtonReset)`
  align-items: center;
  border-radius: 50%;
  display: flex;
  fill: #ffffff;
  height: 30px;
  justify-content: center;
  padding: 0;
  width: 30px;
  
  ${props =>
    props.greenOutline &&
    css`
      border: 2px solid;
      color: ${colors.HEALTHERA_GREEN};
      fill: currentColor;
      margin-right: 12px;
    `}
  
  ${props =>
    props.gray &&
    css`
      border: 2px solid ${colors.GRAY_LIGHT};
      fill: transparent;
      margin-right: 12px;
    `}
  
  ${props =>
    props.green &&
    css`
      background-color: ${colors.HEALTHERA_GREEN};
      fill: #fff;
    `}
  
  ${props =>
    props.red &&
    css`
      background-color: ${colors.HEALTHERA_RED};
      fill: #fff;
    `}

  ${props =>
    props.disabled &&
    css`
      opacity: 0.3;
    `}

  ${props =>
    props.tertiary &&
    css`
      background-color: transparent;
      border: 2px solid ${colors.BLACK};
      fill: ${colors.BLACK};
      opacity: 1;
    `}
`
